import axiosClient from './axiosClient';

const adminPromotionService = {
    getAll: async () => {
        const response = await axiosClient.get('/admin/promotions');
        return response.data;
    },
    getById: async (id) => {
        const response = await axiosClient.get(`/admin/promotions/${id}`);
        return response.data;
    },
    create: async (payload) => {
        const response = await axiosClient.post('/admin/promotions', payload);
        return response.data;
    },
    update: async (id, payload) => {
        const response = await axiosClient.put(`/admin/promotions/${id}`, payload);
        return response.data;
    },
    validateCode: async (code) => {
        const response = await axiosClient.post('/admin/promotions/validate', { code });
        return response.data;
    }
};

export default adminPromotionService;
